"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFileType = void 0;
var UploadFileType;
(function (UploadFileType) {
    UploadFileType[UploadFileType["File"] = 1] = "File";
    UploadFileType[UploadFileType["Google"] = 2] = "Google";
    UploadFileType[UploadFileType["PubWeb"] = 3] = "PubWeb";
    UploadFileType[UploadFileType["SingleFile"] = 4] = "SingleFile";
    UploadFileType[UploadFileType["ImportPipeline"] = 5] = "ImportPipeline";
})(UploadFileType || (exports.UploadFileType = UploadFileType = {}));
